'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Active menu item for N and XN breakpoints
 * @param {String} selector
 * @constructor
 */
function CommonMenuItemActiveNarrow(selector) {
  this.$obj = (0, _jquery2.default)(selector);
}

/**
 * Set item's href
 * @param {String} href
 */
/**
 * @module navigation/commonMenuItemActiveNarrow
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

CommonMenuItemActiveNarrow.prototype.setHref = function (href) {
  this.$obj.attr('href', href);
};

/**
 * @returns {String}
 */
CommonMenuItemActiveNarrow.prototype.getHref = function () {
  return this.$obj.attr('href');
};

/**
 * Set item's title
 * @param {String} title
 */
CommonMenuItemActiveNarrow.prototype.setTitle = function (title) {
  this.$obj.text(title);
};

/**
 * @returns {String}
 */
CommonMenuItemActiveNarrow.prototype.getTitle = function () {
  return this.$obj.text();
};

/**
 * Add classes
 * @param {Array} classes
 */
CommonMenuItemActiveNarrow.prototype.addClasses = function (classes) {
  var jsClasses = classes.join(' ');
  if (!this.$obj.hasClass(jsClasses)) {
    this.$obj.addClass(jsClasses);
  }
};

exports.default = CommonMenuItemActiveNarrow;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/commonMenuItemActiveNarrow.js
// module id = 439
// module chunks = 1